"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERVIEW = exports.INTERVIEW_BASE = exports.BUOY_GPT = exports.BUOY_GPT_BASE = exports.PUBLIC_SITE = exports.PUBLIC_SITE_BASE = exports.SITE_API = exports.SITE_API_BASE = void 0;
function getHost() {
    if (typeof window !== "undefined") {
        return window.location.host;
    }
}
const IS_STAGING = getHost() === "staging.buoyhealth.com";
const IS_PROD = getHost() === "www.buoyhealth.com";
const IS_DEV = getHost()?.includes("dev.buoyhealth.com");
function getRequestBase(port) {
    if (IS_STAGING) {
        return "https://staging.buoyhealth.com";
    }
    if (IS_PROD) {
        return "https://www.buoyhealth.com";
    }
    if (IS_DEV && typeof window !== "undefined") {
        return window.location.origin;
    }
    return `http://localhost:${port}`;
}
exports.SITE_API_BASE = getRequestBase(8001);
exports.SITE_API = `${exports.SITE_API_BASE}/api`;
exports.PUBLIC_SITE_BASE = getRequestBase(3001);
exports.PUBLIC_SITE = `${exports.PUBLIC_SITE_BASE}/api/public-site`;
exports.BUOY_GPT_BASE = getRequestBase(8091);
exports.BUOY_GPT = `${exports.BUOY_GPT_BASE}/buoy-gpt`;
exports.INTERVIEW_BASE = getRequestBase(3007);
exports.INTERVIEW = `${exports.INTERVIEW_BASE}/interview`;
//# sourceMappingURL=requestsSettings.js.map